import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getProductSizeList,
  product_description,
} from "../redux/action/productAction";
import SeoHelmet from "../components/SeoHelmet";
import { Toast } from "../../src/components/Atoms/Toast";
import constants from "../utilities/constants";
import Magnifier from "@oemuap/react-magnifier";
import { Link, useBlocker, useNavigationType } from "react-router-dom";
//userProfile_id
import {
  youMayLikeDataSession,
  youMayLikeData,
} from "../redux/action/cartAction";
import { getAuthModalType } from "../redux/action/authAction";
import { CartItemAddToWishList, productSizeList } from "../utilities/api";
import config from "../utilities/config";
import {
  getImage,
  getshippingDate,
  formatCurrencywithamount,
} from "../utilities/helper";
import Collections from "./Collections";
import { useNavigate } from "react-router-dom";
import {
  addwishlistwithoutlogin,
  getPersionalData,
  productDescriptiontIsLikedChange,
  productListIsLikedChange,
  removewishlistfromstore,
} from "../redux/action/myAccountAction";
import Page404 from "./Page404";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Grid, Pagination, Autoplay } from "swiper/modules";

import { AccordionItem } from "../components/AccordionItem";

function ProductDetails() {
  // For wishlist
  const navigationType = useNavigationType();
  const [liked, setLiked] = useState(false);
  const [tImage, setImage] = useState(null);
  const [wishlistLoading, setwishlistLoading] = useState(false); //wishlist
  const [description, setdescription] = useState("");
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  // const [skuId,setskuId]=(null)
  const { selectedcountrySuccess, dailyMetalPriceSuccess } = useSelector(
    (state) => state.homeReducer
  );
  const { youMayLike_responseSuccess, youMayLike_session_responseSuccess } =
    useSelector((state) => state.youMayLikeReducer);
  const { userProfile_id, cartID, authModalopen, authModalLoading } =
    useSelector((state) => state.authReducer);
  const { shopbyfinishCollectionResponseSuccess } = useSelector(
    (state) => state.homeReducer
  );
  const {
    //wishlist
    wishListDataSuccess,
  } = useSelector((state) => state.myAccountReducer);
  const {
    cart_items_numberResponseSuccess,
    cart_items_numberResponseSuccess_info,
  } = useSelector((state) => state.cartNumberReducer);

  const { productSizeResponseSuccess } = useSelector(
    (state) => state.productSizeReducer
  );
  config.logGeneral &&
    console.log(productSizeResponseSuccess, "productSizeResponseSuccessaaaaa");

  const { add_to_cartResponseSuccess } = useSelector(
    (state) => state.addtocartreducer
  );
  const cartId_for_new = add_to_cartResponseSuccess?.data?.cart_id || null;
  let Localstoragecart = localStorage.getItem("cartDetails");
  let checkproductexists = false;
  const { productDescriptionResponseSuccess, productDescriptionResponseError } =
    useSelector((state) => state.productReducer);
  config.logGeneral &&
    config.logGeneral &&
    console.log(
      productDescriptionResponseSuccess,
      "productDescriptionResponseSuccess999",
      productDescriptionResponseError
    );

  if (Localstoragecart && !userProfile_id) {
    Localstoragecart = JSON.parse(Localstoragecart);
    checkproductexists = Localstoragecart?.products?.some((v) => {
      return v.sku_id == productDescriptionResponseSuccess[0]?.generatedSku;
    });
  }
  if (userProfile_id) {
    checkproductexists = cart_items_numberResponseSuccess_info?.some((v) => {
      return (
        v.productSku === productDescriptionResponseSuccess[0]?.generatedSku
      );
    });
  }

  const productImageArray =
    productDescriptionResponseSuccess[0]?.productListByProductId
      ?.productImagesByProductId?.nodes || [];
  const product_discount_display = (discount) => {
    if (discount && discount !== "0" && discount !== 0) {
      return <span>&nbsp;&nbsp;({discount}% - OFF)</span>;
    } else {
      return <></>;
    }
  };

  useEffect(() => {
    let main_image = productImageArray
      .filter((b) => b.imagePosition === 1)
      .map((e) => getImage(e.imageUrl, "1000X1000"));

    // Ensure `main_image` has a valid image, otherwise use a placeholder
    const finalImage =
      main_image.length > 0
        ? main_image[0]
        : constants.DEFAULT_NO_PRODUCT_IMAGE;

    setImage(finalImage);
    config.logGeneral &&
      console.log(
        productDescriptionResponseSuccess,
        "productDescriptionResponseSuccessbbbbb"
      );
    //productListByProductId?.sizeVarient
    var product_sizes =
      productDescriptionResponseSuccess[0]?.productListByProductId?.sizeVarient?.split(
        ","
      );
    config.logGeneral && console.log(product_sizes, "product_sizes");
    if (productDescriptionResponseSuccess[0]?.skuSize) {
      dispatch(
        getProductSizeList(
          product_sizes,
          productDescriptionResponseSuccess[0]?.productListByProductId
            ?.productId
        )
      );
    }
  }, [productDescriptionResponseSuccess]); // Dependency ensures it updates when data changes

  let enquireLink = () => {
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);
    const whatsappLink = `https://wa.me/919952625252?text=Hi - ${encodedUrl}`;
    window.open(whatsappLink);
  };
  const handleAddToWishlist = (productSku, productId) => {
    setwishlistLoading(true);
    // removing from wishListDataError..
    if (liked) {
      if (userProfile_id) {
        dispatch(
          removewishlistfromstore(
            userProfile_id,
            productId,
            productSku,
            wishListDataSuccess
          )
        );
        // dispatch(getPersionalData(userProfile_id));
        setLiked(!liked);
        Toast("Successfully removed from wishlsit", "success");
        setwishlistLoading(false);
      } else {
        // setLiked(!liked);
        dispatch(addwishlistwithoutlogin(productSku, productId));
        dispatch(getAuthModalType(constants.Login));
        setwishlistLoading(false);
      }
    }
    // add  to wishlist
    else {
      if (userProfile_id) {
        setLiked(!liked);
        CartItemAddToWishList(userProfile_id, productSku, productId)
          .then((response) => {
            // handleRemoveItem(productSku);
            dispatch(getPersionalData(userProfile_id));
            Toast("Successfully added to wishlist", "success");
            setwishlistLoading(false);
          })
          .catch((error) => {
            Toast("Error adding item to wishlist", "error");
            setwishlistLoading(false);
          });
      } else {
        // setLiked(!liked);
        const existingWishlist =
          JSON.parse(localStorage.getItem("wishlistInLocalStorage")) || [];

        // Check if item already exists (optional, if you don't want duplicates)
        const isAlreadyAdded = existingWishlist.some(
          (item) =>
            item.productId === productId && item.productSku === productSku
        );

        if (!isAlreadyAdded) {
          existingWishlist.push({
            page: "productdescription",
            productId,
            productSku,
          });

          localStorage.setItem(
            "wishlistInLocalStorage",
            JSON.stringify(existingWishlist)
          );
        }
        dispatch(addwishlistwithoutlogin(productSku, productId));
        dispatch(getAuthModalType(constants.Login));
        setwishlistLoading(false);
      }
    }
    dispatch(productListIsLikedChange());
  };
  const addRecentlyViewedProduct = (productId) => {
    let viewedProducts =
      JSON.parse(sessionStorage.getItem("viewedProducts")) || [];
    viewedProducts.push(productId);
    viewedProducts = [...new Set(viewedProducts)]; // Remove duplicates
    sessionStorage.setItem("viewedProducts", JSON.stringify(viewedProducts));
  };
  const getRecentlyViewedProducts = () => {
    const viewedProducts =
      JSON.parse(sessionStorage?.getItem("viewedProducts")) || [];
    return viewedProducts;
  };
  let cartAdd = () => {
    if (userProfile_id) {
      let cartDetails = localStorage.getItem("cartDetails");
      config.logGeneral &&
        config.logGeneral &&
        console.log(cartDetails ? "cartdetails present" : "NO cartdetails");
      // Check if the cart exists in localStorage
      if (cartDetails) {
        // Parse cartDetails if it exists
        cartDetails = JSON.parse(cartDetails);
        // Make sure that `productDescriptionResponseSuccess` has data
        if (
          productDescriptionResponseSuccess &&
          productDescriptionResponseSuccess[0]
        ) {
          let newProduct = {
            sku_id: productDescriptionResponseSuccess[0]?.generatedSku || "",
            discountprice: productDescriptionResponseSuccess[0]?.discountPrice,
            discount: productDescriptionResponseSuccess[0]?.discount || 0,
            qty: 1,
            size: productDescriptionResponseSuccess[0]?.skuSize,
            price: productDescriptionResponseSuccess[0]?.markupPrice || "",
            skuUrl: productDescriptionResponseSuccess[0]?.skuUrl || "",
          };
          config.logGeneral && console.log(JSON.stringify(newProduct));

          // Retrieve existing cartDetails from localStorage
          const storedCartDetails = JSON.parse(
            localStorage.getItem("cartDetails") || "{}"
          );

          // Generate or fetch a new cart_id
          const newCartId = cartID || cartId_for_new; // Replace with actual logic to get a new cart_id

          // Update cartDetails with the new cart_id and add the new product
          const updatedCartDetails = {
            ...storedCartDetails,
            cart_id: newCartId,
            user_id: userProfile_id,
            products: [...(storedCartDetails.products || []), newProduct],
          };

          // Save updated cartDetails back to localStorage
          localStorage.setItem(
            "cartDetails",
            JSON.stringify(updatedCartDetails)
          );

          config.logGeneral &&
            config.logGeneral &&
            console.log(updatedCartDetails, "cartDetails z1");

          Toast("Cart updated successfully!", "success");
        } else {
          Toast("Product data is missing", "error");
        }
      } else {
        // If cartDetails does not exist, initialize a new cart

        if (
          productDescriptionResponseSuccess &&
          productDescriptionResponseSuccess[0]
        ) {
          cartDetails = {
            cart_id: cartID,
            user_id: userProfile_id,
            products: [
              {
                sku_id:
                  productDescriptionResponseSuccess[0]?.generatedSku || "",
                qty: 1,
                price: productDescriptionResponseSuccess[0]?.markupPrice || "",
                skuUrl: productDescriptionResponseSuccess[0]?.skuUrl || "",
              },
            ],
          };
          config.logGeneral && console.log(cartDetails, "cartDetails z");
          // alert("sxc")
          config.logGeneral && console.log(JSON.stringify(cartDetails));
          // Save the new cart to localStorage
          localStorage.setItem("cartDetails", JSON.stringify(cartDetails));

          // alert('Cart initialized with the first item!');
        } else {
          Toast("Product data is missing", "error");
        }
      }

      // Call the APIs to update the cart and its price
      // dispatch(Update_Cart_Latest_Price(userProfile_id));
      // dispatch(
      //   Add_To_Cart(userProfile_id, cartDetails.products, cartDetails.cart_id)
      // );
      Navigate(constants.ADDITIONAL_PATH + "/cart");
      // Redirect to cart pageF
      // window.location.href = constants.ADDITIONAL_PATH+"/cart";
    } else {
      let imageoriginalurl =
        productDescriptionResponseSuccess[0]?.productListByProductId?.productImagesByProductId?.nodes.find(
          (img) => img.imagePosition === 1
        )?.imageUrl;
      let cartDetailsinlocalstorage = localStorage.getItem("cartDetails");
      if (cartDetailsinlocalstorage) {
        cartDetailsinlocalstorage = JSON.parse(cartDetailsinlocalstorage);
        config.logGeneral &&
          console.log(
            cartDetailsinlocalstorage,
            "cartDetailsinlocalstorageinalreadyexsistingcart"
          );
        let newproduct = {
          sku_id: productDescriptionResponseSuccess[0]?.generatedSku || "",
          qty: 1,
          size: productDescriptionResponseSuccess[0]?.skuSize,
          skuUrl: productDescriptionResponseSuccess[0]?.skuUrl || "",
          imageurl: getImage(imageoriginalurl, "300X300"),
          discountprice: productDescriptionResponseSuccess[0]?.discountPrice,
          discount: productDescriptionResponseSuccess[0]?.discount || 0,
          productname:
            productDescriptionResponseSuccess[0]?.productListByProductId
              ?.productName,
          price: productDescriptionResponseSuccess[0]?.markupPrice || "",
        };
        cartDetailsinlocalstorage.products.push(newproduct);
        localStorage.setItem(
          "cartDetails",
          JSON.stringify(cartDetailsinlocalstorage)
        );
        window.location.href = constants.ADDITIONAL_PATH + "/cart";
      } else {
        let cartDetails = {
          cart_id: "",
          user_id: "",
          products: [
            {
              sku_id: productDescriptionResponseSuccess[0]?.generatedSku || "",
              qty: 1,
              imageurl: getImage(imageoriginalurl, "300X300"),
              size: productDescriptionResponseSuccess[0]?.skuSize,
              skuUrl: productDescriptionResponseSuccess[0]?.skuUrl || "",
              discountprice:
                productDescriptionResponseSuccess[0]?.discountPrice,
              discount: productDescriptionResponseSuccess[0]?.discount || 0,
              productname:
                productDescriptionResponseSuccess[0]?.productListByProductId
                  ?.productName,
              price: productDescriptionResponseSuccess[0]?.markupPrice || "",
            },
          ],
        };
        localStorage.setItem("cartDetails", JSON.stringify(cartDetails));
        window.location.href = constants.ADDITIONAL_PATH + "/cart";
      }
    }
  };
  const handleProductDescription = (skuId) => {
    dispatch(product_description(skuId));
  };
  let buyNow = () => {
    if (userProfile_id) {
      let cartDetails = localStorage.getItem("cartDetails");
      config.logGeneral &&
        config.logGeneral &&
        console.log(cartDetails ? "cartdetails present" : "NO cartdetails");
      // Check if the cart exists in localStorage
      if (cartDetails) {
        // Parse cartDetails if it exists
        cartDetails = JSON.parse(cartDetails);
        // Make sure that `productDescriptionResponseSuccess` has data
        if (
          productDescriptionResponseSuccess &&
          productDescriptionResponseSuccess[0]
        ) {
          let newProduct = {
            sku_id: productDescriptionResponseSuccess[0]?.generatedSku || "",
            discountprice: productDescriptionResponseSuccess[0]?.discountPrice,
            discount: productDescriptionResponseSuccess[0]?.discount || 0,
            qty: 1,
            size: productDescriptionResponseSuccess[0]?.skuSize,
            price: productDescriptionResponseSuccess[0]?.markupPrice || "",
            skuUrl: productDescriptionResponseSuccess[0]?.skuUrl || "",
          };
          config.logGeneral && console.log(JSON.stringify(newProduct));

          // Retrieve existing cartDetails from localStorage
          const storedCartDetails = JSON.parse(
            localStorage.getItem("cartDetails") || "{}"
          );

          // Generate or fetch a new cart_id
          const newCartId = cartID || cartId_for_new; // Replace with actual logic to get a new cart_id

          // Update cartDetails with the new cart_id and add the new product
          const updatedCartDetails = {
            ...storedCartDetails,
            cart_id: newCartId,
            user_id: userProfile_id,
            products: [...(storedCartDetails.products || []), newProduct],
          };

          // Save updated cartDetails back to localStorage
          localStorage.setItem(
            "cartDetails",
            JSON.stringify(updatedCartDetails)
          );

          config.logGeneral &&
            console.log(updatedCartDetails, "cartDetails z1");

          Toast("Cart updated successfully!", "success");
        } else {
          Toast("Product data is missing", "error");
        }
      } else {
        // If cartDetails does not exist, initialize a new cart

        if (
          productDescriptionResponseSuccess &&
          productDescriptionResponseSuccess[0]
        ) {
          cartDetails = {
            cart_id: cartID,
            user_id: userProfile_id,
            products: [
              {
                sku_id:
                  productDescriptionResponseSuccess[0]?.generatedSku || "",
                qty: 1,
                skuUrl: productDescriptionResponseSuccess[0]?.skuUrl || "",
                price: productDescriptionResponseSuccess[0]?.markupPrice || "",
              },
            ],
          };
          config.logGeneral && console.log(cartDetails, "cartDetails z");
          // alert("sxc")
          config.logGeneral && console.log(JSON.stringify(cartDetails));
          // Save the new cart to localStorage
          localStorage.setItem("cartDetails", JSON.stringify(cartDetails));

          // alert('Cart initialized with the first item!');
        } else {
          Toast("Product data is missing", "error");
        }
      }

      // Call the APIs to update the cart and its price
      // dispatch(Update_Cart_Latest_Price(userProfile_id));
      // dispatch(
      //   Add_To_Cart(userProfile_id, cartDetails.products, cartDetails.cart_id)
      // );
      Navigate(constants.ADDITIONAL_PATH + "/checkout");
      // Redirect to cart pageF
      // window.location.href = constants.ADDITIONAL_PATH+"/cart";
    } else {
      let imageoriginalurl =
        productDescriptionResponseSuccess[0]?.productListByProductId?.productImagesByProductId?.nodes.find(
          (img) => img.imagePosition === 1
        )?.imageUrl;
      let cartDetailsinlocalstorage = localStorage.getItem("cartDetails");
      if (cartDetailsinlocalstorage) {
        cartDetailsinlocalstorage = JSON.parse(cartDetailsinlocalstorage);
        config.logGeneral &&
          config.logGeneral &&
          console.log(
            cartDetailsinlocalstorage,
            "cartDetailsinlocalstorageinalreadyexsistingcart"
          );
        let newproduct = {
          sku_id: productDescriptionResponseSuccess[0]?.generatedSku || "",
          qty: 1,
          size: productDescriptionResponseSuccess[0]?.skuSize,
          skuUrl: productDescriptionResponseSuccess[0]?.skuUrl || "",
          imageurl: getImage(imageoriginalurl, "300X300"),
          discountprice: productDescriptionResponseSuccess[0]?.discountPrice,
          discount: productDescriptionResponseSuccess[0]?.discount || 0,
          productname:
            productDescriptionResponseSuccess[0]?.productListByProductId
              ?.productName,
          price: productDescriptionResponseSuccess[0]?.markupPrice || "",
        };
        cartDetailsinlocalstorage.products.push(newproduct);
        localStorage.setItem(
          "cartDetails",
          JSON.stringify(cartDetailsinlocalstorage)
        );
        window.location.href = constants.ADDITIONAL_PATH + "/checkout";
      } else {
        let cartDetails = {
          cart_id: "",
          user_id: "",
          products: [
            {
              sku_id: productDescriptionResponseSuccess[0]?.generatedSku || "",
              qty: 1,
              imageurl: getImage(imageoriginalurl, "300X300"),
              skuUrl: productDescriptionResponseSuccess[0]?.skuUrl || "",
              discountprice:
                productDescriptionResponseSuccess[0]?.discountPrice,
              discount: productDescriptionResponseSuccess[0]?.discount || 0,
              productname:
                productDescriptionResponseSuccess[0]?.productListByProductId
                  ?.productName,
              price: productDescriptionResponseSuccess[0]?.markupPrice || "",
            },
          ],
        };
        localStorage.setItem("cartDetails", JSON.stringify(cartDetails));
        window.location.href = constants.ADDITIONAL_PATH + "/checkout";
      }
    }
  };
  useEffect(() => {
    const queryString = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    const skuId = searchParams.get("sku_id");

    if (skuId) {
      dispatch(product_description(skuId)); // Dispatch the action with the skuId
    }
  }, []); // Empty dependency array ensures this runs only once on mount
  
  useEffect(() => {
    // Check if the product is already in the wishlist
    if (
      wishListDataSuccess &&
      wishListDataSuccess.length > 0 &&
      productDescriptionResponseSuccess &&
      productDescriptionResponseSuccess.length > 0
    ) {
      const isProductInWishlist = wishListDataSuccess.some(
        (item) =>
          item.generatedsku ===
          productDescriptionResponseSuccess[0]?.generatedSku
      );
      config.logGeneral && console.log(isProductInWishlist);
      setLiked(isProductInWishlist);
    } else {
      setLiked(false); // Default to not liked if wishlist is empty or not loaded
    }
    if (
      productDescriptionResponseSuccess &&
      productDescriptionResponseSuccess.length > 0
    ) {
      dispatch(
        youMayLikeData(
          productDescriptionResponseSuccess[0]?.skuId,
          productDescriptionResponseSuccess[0]?.discountPrice,
          productDescriptionResponseSuccess[0]?.productListByProductId
            ?.productType
        )
      );
      setdescription(
        productDescriptionResponseSuccess[0]?.productListByProductId
          ?.prodDescription ||
          productDescriptionResponseSuccess[0]?.transSkuDescriptionsBySkuId
            .nodes[0]?.skuDescription ||
          ""
      );
      const productId = productDescriptionResponseSuccess[0]?.generatedSku;
      productDescriptionResponseSuccess?.[0]?.productListByProductId
        ?.isactive === true && addRecentlyViewedProduct(productId); //has to be changed
      const viewedProducts = getRecentlyViewedProducts();

      viewedProducts &&
        viewedProducts?.length > 0 &&
        dispatch(youMayLikeDataSession(viewedProducts));
    }
  }, [wishListDataSuccess, productDescriptionResponseSuccess]);
  if (productDescriptionResponseError) {
    return <Page404 />;
  }
  return productDescriptionResponseSuccess?.length > 0 ? (
    <>
      <SeoHelmet 
        productData={{
          productName: productDescriptionResponseSuccess[0]?.productListByProductId?.productName,
          skuDescription: description,
          imageUrl: productImageArray[0]?.imageUrl
        }}
      />
      <div className="lg:pt-5 pt-0">
        {/* Main Image For Mobile */}
        <div className="lg:hidden block">
          <Swiper
            slidesPerView={1.2} // Show part of prev/next slide
            spaceBetween={0.5} // Space between slides
            centeredSlides={true} // Center the active slide
            autoplay={{
              delay: 2500,
              disableOnInteraction: true,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[Autoplay, Pagination]}
            className="mySwiper swipper-detail !pb-6"
          >
            {productImageArray?.map((image, index) => {
              const imageUrl = getImage(image.imageUrl);
              return (
                <SwiperSlide key={index} className="relative">
                  <Magnifier
                    src={imageUrl}
                    alt="Product Image"
                    className={`h-auto cursor-pointer px-2 ${
                      tImage === imageUrl ? " " : "border-transparent"
                    }`}
                    onClick={() => setImage(imageUrl)}
                  />
                  <button
                    onClick={() => {
                      handleAddToWishlist(
                        productDescriptionResponseSuccess[0]?.generatedSku,
                        productDescriptionResponseSuccess[0]
                          ?.productListByProductId?.productId
                      );
                    }}
                    className="focus:outline-none"
                    disabled={wishlistLoading}
                  >
                    <img
                      src={
                        liked || productDescriptionResponseSuccess[0].isLiked
                          ? constants.DEFAULT_IMAGE + "/heart-filled.svg"
                          : constants.DEFAULT_IMAGE + "/heart-outline.svg"
                      }
                      alt="Wishlist"
                      className="lg:w-8 lg:h-8 !w-6 !h-6 transition-all duration-300 absolute lg:top-3 lg:right-3 top-7 right-7"
                    />
                  </button>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        {/* Main Image For Mobile */}

        <div className="container mx-auto">
          <div className="flex lg:gap-8 gap-0 lg:p-0 xl:p-0 px-5">
            <div className="md:w-1/2 w-full lg:block hidden">
              <div className="flex justify-start">
                <div className="flex-col lg:inline-block pr-5 space-y-3 w-[200px]">
                  {productImageArray?.map((image, index) => {
                    const imageUrl = getImage(image.imageUrl);
                    return (
                      <img
                        key={index}
                        src={imageUrl}
                        alt="Product Image"
                        className={`h-auto rounded-md cursor-pointer border ${
                          tImage === imageUrl
                            ? "border-[#5B5B5B] shadow-2xl"
                            : "border-transparent"
                        }`}
                        onClick={() => setImage(imageUrl)}
                      />
                    );
                  })}
                </div>
                <div className="lg:mb-4 mb-0 col-span-2 relative">
                  <Magnifier
                    src={`${tImage}?t=${new Date().getTime()}`}
                    alt="Product"
                    className="w-full"
                  />
                  <button
                    onClick={() => {
                      handleAddToWishlist(
                        // item?.productSku,
                        productDescriptionResponseSuccess[0]?.generatedSku,
                        productDescriptionResponseSuccess[0]
                          ?.productListByProductId?.productId
                      );
                    }}
                    className="focus:outline-none"
                    disabled={wishlistLoading}
                  >
                    <img
                      src={
                        liked
                          ? constants.DEFAULT_IMAGE + "/heart-filled.svg"
                          : constants.DEFAULT_IMAGE + "/heart-outline.svg"
                      }
                      alt="Wishlist"
                      className="lg:w-8 lg:h-8 w-6 h-6 transition-all duration-300 absolute lg:top-3 lg:right-3 top-7 right-7"
                    />
                  </button>

                  {/* Web */}
                  <div className="mt-8 lg:grid md:grid-cols-2 lg:grid-cols-5 gap-4 hidden">
                    <div className="text-center">
                      <img
                        src={constants.DEFAULT_IMAGE + "/img-1.svg"}
                        alt="Icon"
                        className="mx-auto"
                      />
                      <p className="font-century text-xs font-medium text-black mt-2">
                        Certified Jewellery
                      </p>
                    </div>
                    <div className="text-center">
                      <img
                        src={constants.DEFAULT_IMAGE + "/img-2.svg"}
                        alt="Icon"
                        className="mx-auto"
                      />
                      <p className="font-century text-xs font-medium text-black mt-2">
                        Diverse Styles
                      </p>
                    </div>
                    <div className="text-center">
                      <img
                        src={constants.DEFAULT_IMAGE + "/img-3.svg"}
                        alt="Icon"
                        className="mx-auto"
                      />
                      <p className="font-century text-xs font-medium text-black mt-2">
                        Hypoallergenic
                      </p>
                    </div>
                    <div className="text-center">
                      <img
                        src={constants.DEFAULT_IMAGE + "/img-4.svg"}
                        alt="Icon"
                        className="mx-auto"
                      />
                      <p className="font-century text-xs font-medium text-black mt-2">
                        From NAC
                      </p>
                    </div>
                    <div className="text-center">
                      <img
                        src={constants.DEFAULT_IMAGE + "/img-5.svg"}
                        alt="Icon"
                        className="mx-auto"
                      />
                      <p className="font-century text-xs font-medium text-black mt-2">
                        Secured Payment
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="md:w-1/3 w-full lg:text-left text-center pt-3 lg:p-0">
              <h1 className="lg:text-[34px] text-2xl font-medium text-[#242424] font-tiemann mb-1">
                {
                  productDescriptionResponseSuccess[0]?.productListByProductId
                    ?.productName
                }
              </h1>
              <span className="font-century font-medium lg:text-base text-sm lg:text-[#242424] text-[#5F5F5F]">
                {
                  productDescriptionResponseSuccess[0]?.productListByProductId
                    ?.productId
                }
              </span>
              <p className="font-century text-xl text-[#525252] font-normal mt-2">
                {productDescriptionResponseSuccess[0]?.discountPrice !==
                  productDescriptionResponseSuccess[0]?.markupPrice && (
                  <>
                    <span className="line-through">
                      {formatCurrencywithamount(
                        productDescriptionResponseSuccess[0]?.discountPrice,
                        selectedcountrySuccess?.currencyAlias
                          ? selectedcountrySuccess?.currencyAlias
                          : "",
                        selectedcountrySuccess?.iso
                          ? `en-${selectedcountrySuccess?.iso}`
                          : "",
                        dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                      )}
                    </span>{" "}
                  </>
                )}
                {formatCurrencywithamount(
                  productDescriptionResponseSuccess[0]?.markupPrice,
                  selectedcountrySuccess?.currencyAlias
                    ? selectedcountrySuccess?.currencyAlias
                    : "",
                  selectedcountrySuccess?.iso
                    ? `en-${selectedcountrySuccess?.iso}`
                    : "",
                  dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                )}
                {product_discount_display(
                  productDescriptionResponseSuccess[0]?.discount
                )}
              </p>
              <p className="text-sm text-[#242424] font-medium">
                Tax Included. Ships by {getshippingDate()}.
              </p>

              {productDescriptionResponseSuccess?.[0]?.productListByProductId
                ?.isactive === true && (
                <div className="md:my-6 my-4 lg:flex justify-start">
                  <button
                    className="border border-[#06ab9f] text-[#06ab9f] px-6 py-2 lg:mb-0 mb-3 md:hover:bg-white md:hover:text-[#06ab9f] w-full uppercase font-semibold text-sm tracking-widest text-[14px] btn-stroke"
                    onClick={() => {
                      if (checkproductexists) {
                        window.location.href = "/styloriSilver/checkout";
                      } else {
                        buyNow();
                      }
                    }}
                  >
                    {checkproductexists ? `In Bag` : `Buy Now`}
                  </button>
                  <button
                    className="lg:ml-4 ml-0  text-white px-6 py-2 border border-[#51b6ad] w-full uppercase flex justify-center items-center text-[14px] tracking-widest font-semibold btn-transition"
                    // onClick={checkproductexists ? () => { } : cartAdd}
                    onClick={() => {
                      if (checkproductexists) {
                        window.location.href = "/styloriSilver/cart";
                      } else {
                        cartAdd();
                      }
                    }}
                  >
                    <img
                      src={constants.DEFAULT_IMAGE + "/cart-button.svg"}
                      className="w-4 h-4"
                    />
                    <span className="pl-2">
                      {checkproductexists ? `In Cart` : `Add to Cart`}
                    </span>
                    <div class="transition"></div>
                  </button>
                  <p className="font-[#242424] text-sm font-medium lg:hidden mt-3">
                    Shipping Calculated at Checkout
                  </p>
                </div>
              )}
              <div className="flex md:flex-row md:justify-between md:gap-0 flex-col justify-center items-center gap-3 md:my-6 mt-4 mb-5">
                <div className="flex bg-[#E8F4F3] w-[250px] rounded-[4px] p-2 gap-2">
                  <img src={constants.DEFAULT_IMAGE + "/detail-world.svg"} />
                  <p className="text-[#242626] font-normal text-base font-tiemann tracking-wide">
                    Worldwide shipping available
                  </p>
                </div>
                <div className="flex bg-[#E8F4F3] w-[250px] rounded-[4px] p-2 gap-2">
                  <img src={constants.DEFAULT_IMAGE + "/detail-shipping.svg"} />
                  <p className="text-[#242626] font-normal text-base font-tiemann tracking-wide">
                    Free Shipping across India
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-4 mb-5 lg:justify-start justify-between">
                <div className="flex items-center space-x-1 gap-2">
                  <div className="bg-[#EBF3F3] rounded-full p-3">
                    <img
                      src={constants.DEFAULT_IMAGE + "/type.svg"}
                      alt="Metal"
                    />
                  </div>
                  <div className="text-left">
                    <p className="font-century text-sm text-[#525252] font-medium">
                      Metal Type / Finish
                    </p>
                    <p className="font-century text-[#242424] text-base font-semibold">
                      {productDescriptionResponseSuccess[0]?.purity} /{" "}
                      {productDescriptionResponseSuccess[0]?.metalColor}
                      {productDescriptionResponseSuccess[0]?.metalColor ===
                        "Gold" && " Plated"}
                    </p>
                  </div>
                </div>
                {/* <div className="flex items-center space-x-1 gap-2">
                <div className="bg-[#EBF3F3] rounded-full p-3">
                  <img
                    src={constants.DEFAULT_IMAGE + "/weight.svg"}
                    alt="Weight"
                  />
                </div>
                <div className="text-left">
                  <p className="font-century text-sm text-[#525252] font-medium">
                    Weight (in gm)
                  </p>
                  <p className="font-century text-[#242424] text-base font-semibold">
                    {productDescriptionResponseSuccess[0]?.skuWeight}
                  </p>
                </div>
              </div> */}
              </div>
              {/* <div className="">
                <div className="flex gap-2 items-center">
                  <img src={size} className="w-5 h-5" />
                  <h5 className="font-tiemann text-2xl font-bold text-[#242424]">Select Size</h5>
                </div>
                <div className="flex gap-4 mt-3">
                  <p className="border border-[#E7EAEE] text-[#191D23] font-light text-sm font-century py-2 px-8 rounded-[4px]">10</p>
                  <p className="border border-[#E7EAEE] text-[#191D23] font-light text-sm font-century py-2 px-8 rounded-[4px]">12</p>
                  <p className="border border-[#E7EAEE] text-[#191D23] font-light text-sm font-century py-2 px-8 rounded-[4px]">14</p>
                  <p className="border border-[#E7EAEE] text-[#191D23] font-light text-sm font-century py-2 px-8 rounded-[4px]">16</p>
                </div>
              </div> */}
              {productDescriptionResponseSuccess[0]?.skuSize &&
                productSizeResponseSuccess?.length > 0 && (
                  <div>
                    <div className="flex gap-2 items-center">
                      <img
                        src={constants.DEFAULT_IMAGE + "/size.svg"}
                        alt="Weight"
                        className="w-5 h-5"
                      />
                      <h5 className="font-tiemann text-2xl font-bold text-[#242424]">
                        Select Size
                      </h5>
                    </div>
                    <div className="flex gap-4 mt-3">
                      {productSizeResponseSuccess?.map((sizeinfo, index) => (
                        <p
                          className={`${
                            sizeinfo?.skuSize ===
                            productDescriptionResponseSuccess[0]?.skuSize
                              ? "border-[#06ab9f]" // green border if selected
                              : "border-[#E7EAEE]" // default border
                          } border text-[#191D23] font-light text-sm font-century py-2 px-8 rounded-[4px] cursor-pointer transition`}
                          onClick={() =>
                            handleProductDescription(sizeinfo?.skuId)
                          }
                        >
                          {sizeinfo?.skuSize}"
                        </p>
                      ))}
                    </div>
                  </div>
                )}

              <AccordionItem page="details" header="Description">
                <p className="text-sm font-medium text-[#242424] font-century mb-2 text-left">
                  {
                    // productDescriptionResponseSuccess[0]
                    //   ?.transSkuDescriptionsBySkuId?.nodes[0]?.skuDescription

                    description
                      .replace(
                        productDescriptionResponseSuccess[0]?.skuWeight,
                        ""
                      )
                      .replace("gm", "")
                  }
                </p>
              </AccordionItem>
              <AccordionItem page="details" header="Jewellery Care">
                <h2 className="text-base font-semibold text-[#242424] font-century text-left">
                  Do's
                </h2>
                <p className="text-sm font-medium text-[#242424] font-century mb-2 text-left">
                  Store your jewellery in zip lock bag or air tight plastic box
                  Wipe gently after use Use Frangrance 30 before wearing
                </p>

                <h2 className="text-base font-semibold text-[#242424] font-century text-left">
                  Dont's
                </h2>
                <p className="text-sm font-medium text-[#242424] font-century mb-2 text-left">
                  Dont use soap, tooth paste or detergent to clean your
                  jewellery Dont store jewellery in velvet linedor velvet box
                  Dont roll or place the jewellery in clothes
                </p>
              </AccordionItem>
              <div className="lg:mt-32 mt-10">
                <button
                  className=" w-full border border-[#06ab9f] font-semibold text-sm tracking-wider text-[#06ab9f] px-6 py-2 md:hover:text-white uppercase btn-stroke"
                  onClick={enquireLink}
                >
                  Get In Touch
                </button>
              </div>
            </div>
          </div>

          {/* Mobile */}
          <div className="lg:hidden block mt-8 px-4">
            <Swiper
              slidesPerView={4}
              grid={{
                rows: 1,
              }}
              spaceBetween={10}
              autoplay={{
                delay: 2500, // Adjust the delay time as needed
                disableOnInteraction: false, // Set to true if you want to stop autoplay on user interaction
              }}
              // loop={true}
              modules={[Grid, Autoplay]}
              className="mySwiper"
            >
              <SwiperSlide className="!mr-0">
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={constants.DEFAULT_IMAGE + "/img-1.svg"}
                    alt="Icon"
                    className="!w-16 !h-16"
                  />
                  <p className="font-century text-xs font-medium text-black mt-2">
                    Certified Jewellery
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="!mr-0">
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={constants.DEFAULT_IMAGE + "/img-2.svg"}
                    alt="Icon"
                    className="!w-16 !h-16"
                  />
                  <p className="font-century text-xs font-medium text-black mt-2">
                    Diverse Styles
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="!mr-0">
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={constants.DEFAULT_IMAGE + "/img-3.svg"}
                    alt="Icon"
                    className="!w-16 !h-16"
                  />
                  <p className="font-century text-xs font-medium text-black mt-2">
                    Hypoallergenic
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="!mr-0">
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={constants.DEFAULT_IMAGE + "/img-4.svg"}
                    alt="Icon"
                    className="!w-16 !h-16"
                  />
                  <p className="font-century text-xs font-medium text-black mt-2">
                    From NAC
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="!mr-0">
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={constants.DEFAULT_IMAGE + "/img-5.svg"}
                    alt="Icon"
                    className="!w-16 !h-16"
                  />
                  <p className="font-century text-xs font-medium text-black mt-2">
                    Secured Payment
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>

          <Link to={constants.ADDITIONAL_PATH + "/contactus"}>
            <button className="hidden lg:flex bg-white fixed top-1/2 transform rotate-[270deg] lg:-left-14 -left-12 rounded-bl-2xl rounded-br-2xl lg:py-2 lg:px-4 py-2 px-3 text-[#020307] font-tiemann font-normal lg:text-xl text-base shadow-md z-[1]">
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="transform rotate-[90deg] pt-1"
              >
                <path
                  d="M14.8063 1.4124C14.0725 1.88413 13.3649 2.35585 12.6311 2.82758C12.4739 2.9324 12.3691 2.9324 12.2118 2.82758C11.5042 2.35585 10.7967 1.91034 10.0891 1.43861C9.25045 0.888265 8.43803 1.17654 8.09734 2.11999C7.80906 2.9062 7.49458 3.6924 7.20631 4.47861C7.15389 4.63585 7.04906 4.71447 6.86562 4.71447C6.00079 4.74068 5.13596 4.79309 4.29734 4.84551C3.3801 4.89792 2.85596 5.6055 3.09182 6.49654C3.30148 7.33516 3.53734 8.17378 3.7732 8.98619C3.82562 9.16964 3.7732 9.27447 3.64217 9.40551C2.96079 9.92964 2.30561 10.48 1.65044 11.0041C0.916649 11.5807 0.916649 12.4717 1.65044 13.0745C2.30561 13.5986 2.96079 14.149 3.61596 14.6469C3.79941 14.7779 3.82562 14.909 3.7732 15.1186C3.53734 15.931 3.32769 16.7434 3.17044 17.32C2.90837 18.4469 3.35389 19.1283 4.29734 19.1807C5.16217 19.2331 6.027 19.2855 6.91803 19.3117C7.10148 19.3117 7.1801 19.3903 7.25872 19.5476C7.5732 20.36 7.88768 21.1724 8.20217 21.9848C8.54286 22.8234 9.35527 23.0855 10.1153 22.5876C10.8491 22.1158 11.5567 21.6441 12.2904 21.1724C12.4477 21.0676 12.5525 21.0676 12.736 21.1724C13.4698 21.6703 14.2036 22.1421 14.9635 22.6138C15.6711 23.0593 16.5098 22.771 16.8242 21.9848C17.1387 21.1724 17.4532 20.3338 17.7677 19.5214C17.8201 19.3379 17.9249 19.2855 18.1084 19.2855C18.947 19.2593 19.7594 19.1545 20.598 19.1545C21.4367 19.1545 22.1967 18.4207 21.8822 17.3986C21.6201 16.5862 21.4366 15.7738 21.2008 14.9614C21.1484 14.8041 21.1746 14.6993 21.3318 14.5945C22.0132 14.0441 22.6684 13.52 23.3498 12.9697C24.0835 12.3669 24.0835 11.5021 23.3498 10.9255C22.6684 10.3752 22.0132 9.85103 21.3318 9.30069C21.2008 9.19586 21.1484 9.11724 21.2008 8.93379C21.4366 8.09517 21.6463 7.25655 21.8822 6.41793C22.118 5.5531 21.5939 4.81931 20.7029 4.7931C19.838 4.74069 18.9732 4.68828 18.0822 4.66207C17.8725 4.66207 17.7939 4.55724 17.7415 4.4C17.4532 3.61379 17.1387 2.80138 16.8242 2.01517C16.4049 1.17654 15.5663 0.914472 14.8063 1.4124ZM10.5084 7.67585L15.7498 12.9172C15.8808 13.0483 15.9856 13.2317 16.0118 13.4152C16.0118 13.4676 16.038 13.5462 16.038 13.5986C16.038 13.8345 15.9332 14.0965 15.7498 14.28L13.6008 16.429C13.2339 16.7958 12.6311 16.7958 12.2642 16.429C11.8973 16.0621 11.8973 15.4593 12.2642 15.0924L13.7318 13.6248L9.17182 9.06481C8.80493 8.69792 8.80493 8.09516 9.17182 7.72826C9.53872 7.30895 10.1415 7.30895 10.5084 7.67585Z"
                  fill="#15AB9E"
                />
              </svg>
              Get Enquiry
            </button>
          </Link>
        </div>
        <div className="relative lg:mt-20 mt-5 lg:block flex justify-center">
          <div className="">
            <img
              src={constants.DEFAULT_IMAGE + "/product-banner.jpg"}
              className="w-full h-full lg:block hidden"
            />
            <img
              src={constants.DEFAULT_IMAGE + "/product-details-mob.jpg"}
              alt="Icon"
              className="w-full h-full lg:hidden block"
            />
          </div>
          <div className="bg-white absolute lg:top-1/2 top-56 lg:w-2/5 w-11/12 lg:p-10 p-4 -translate-y-1/2 shadow-md">
            {/* <span className="lg:text-base text-xs font-medium font-century text-[#242424]">
              Since1987
            </span> */}
            <h2 className="lg:text-[34px] text-[17px] font-tiemann font-normal mb-2 text-[#242424]">
              From the House of Nac
            </h2>
            <p className="lg:text-xl text-xs font-medium font-century text-[#242424]">
              NAC Jewellers blends tradition with modern elegance. Each intricate, bespoke piece reflects timeless craftsmanship, offering unique designs that celebrate heritage with a fresh, contemporary twist.
            </p>
          </div>
        </div>
        {/* <Slider /> */}
        <div className="container mx-auto text-center lg:mt-20 mt-32 lg:mb-20 mb-0 lg:p-0 p-5">
          <div className="lg:mb-20">
            <div className="flex items-center lg:mb-10 mb-5 justify-center">
              <div className="flex-grow border-t border-[#6D6E71] lg:block hidden"></div>
              <h2 className="px-3 text-[#1A1A1A] font-tiemann font-normal lg:text-[40px] text-2xl">
                You may also like
              </h2>
              <div className="flex-grow border-t border-[#6D6E71] lg:block hidden"></div>
            </div>
            <Collections
              // bestseller={shopbyfinishCollectionResponseSuccess}
              youMayLike_responseSuccess={youMayLike_responseSuccess}
            />
          </div>
          <div className="lg:mb-20 mt-5">
            <div className="flex items-center lg:mb-10 mb-5 justify-center">
              <div className="flex-grow border-t border-[#6D6E71] lg:block hidden"></div>
              <h2 className="px-3 text-[#1A1A1A] font-tiemann font-normal lg:text-[40px] text-2xl">
                Recently viewed
              </h2>
              <div className="flex-grow border-t border-[#6D6E71] lg:block hidden"></div>
            </div>
            <Collections
              youMayLike_responseSuccess={
                youMayLike_session_responseSuccess || youMayLike_responseSuccess
              }
            />
          </div>
        </div>
        <hr className="border border-customGreen border-width mb-5"></hr>

        <div className="container mx-auto lg:flex gap-4 lg:my-16 my-2 lg:p-0 px-5 hidden">
          <div className="flex-col text-center lg:mb-0 mb-5">
            <img src={constants.DEFAULT_IMAGE + "/studs-set.jpg"} />
            <h5 className="font-tiemann lg:text-2xl text-[18px] text-black font-normal mt-2 lg:mb-2 mb-0">
              Studs
            </h5>
            <p className="font-century font-medium lg:text-sm text-xs text-[#676767] lg:mb-4 mb-2 lg:h-9 h-auto">
              Everyday sparkle, redefined. Explore silver studs in Nakshi,
              Kundan, and Zircon finishes.
            </p>
            <Link
              to={
                constants.ADDITIONAL_PATH +
                "/earrings-silver-studs-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
              }
            >
              <button className="font-medium lg:text-sm text-xs font-century text-[#676767] border border-customGreen uppercase lg:px-5 lg:py-2 px-5 py-2">
                Shop Now
              </button>
            </Link>
          </div>
          <div className="flex-col text-center lg:mb-0 mb-5">
            <img
              src={constants.DEFAULT_IMAGE + "/pendant-set.jpg"}
              alt="Icon"
              className="mx-auto"
            />
            <h5 className="font-tiemann  lg:text-2xl text-[18px] text-black font-normal mt-4 lg:mb-2 mb-0">
              Pendants
            </h5>
            <p className="font-century font-medium lg:text-sm text-xs text-[#676767] lg:mb-4 mb-2 lg:h-9 h-auto">
              Grace your neckline with pendants that balance shine and
              tradition.
            </p>
            <Link
              to={
                constants.ADDITIONAL_PATH +
                "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
              }
            >
              <button className="font-medium lg:text-sm text-xs font-century text-[#676767] border border-customGreen uppercase px-5 py-2">
                Shop Now
              </button>
            </Link>
          </div>
          <div className="flex-col text-center lg:mb-0 mb-5">
            <img
              src={constants.DEFAULT_IMAGE + "/bangle-set.jpg"}
              alt="Icon"
              className="mx-auto"
            />
            <h5 className="font-tiemann lg:text-2xl text-[18px] text-black font-normal mt-4 lg:mb-2 mb-0">
              Bangles
            </h5>
            <p className="font-century font-medium lg:text-sm text-xs text-[#676767] lg:mb-4 mb-2 lg:h-9 h-auto">
              Stack up on charm with single silver bangles in heritage and
              modern styles.
            </p>
            <Link
              to={
                constants.ADDITIONAL_PATH +
                "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
              }
            >
              <button className="font-medium lg:text-sm text-xs font-century text-[#676767] border border-customGreen uppercase px-5 py-2">
                Shop Now
              </button>
            </Link>
          </div>
        </div>
        <div className="lg:hidden block px-5">
          <Swiper
            slidesPerView={1}
            grid={{
              rows: 1,
            }}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 2500, // Adjust the delay time as needed
              disableOnInteraction: false, // Set to true if you want to stop autoplay on user interaction
            }}
            modules={[Grid, Pagination, Autoplay]}
            className="mySwiper swiper-image"
          >
            <SwiperSlide className="!mr-0">
              <div className="flex-col text-center lg:mb-0 mb-5">
                <img src={constants.DEFAULT_IMAGE + "/studs-set.jpg"} />
                <h5 className="font-tiemann lg:text-2xl text-[18px] text-black font-normal mt-2 lg:mb-2 mb-0">
                  Studs
                </h5>
                <p className="font-century font-medium lg:text-sm text-xs text-[#676767] lg:mb-4 mb-2 lg:h-9 h-auto">
                  Everyday sparkle, redefined. Explore silver studs in Nakshi,
                  Kundan, and Zircon finishes.
                </p>
                <Link
                  to={
                    constants.ADDITIONAL_PATH +
                    "/earrings-silver-studs-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
                  }
                >
                  <button className="font-medium lg:text-sm text-xs font-century text-[#676767] border border-customGreen uppercase lg:px-5 lg:py-2 px-5 py-2">
                    Shop Now
                  </button>
                </Link>
              </div>
            </SwiperSlide>

            <SwiperSlide className="!mr-0">
              <div className="flex-col text-center lg:mb-0 mb-5">
                <img
                  src={constants.DEFAULT_IMAGE + "/pendant-set.jpg"}
                  alt="Icon"
                  className="mx-auto"
                />
                <h5 className="font-tiemann lg:text-2xl text-[18px] text-black font-normal mt-2 lg:mb-2 mb-0">
                  Pendants
                </h5>
                <p className="font-century font-medium lg:text-sm text-xs text-[#676767] lg:mb-4 mb-2 lg:h-9 h-auto">
                  Grace your neckline with pendants that balance shine and
                  tradition.
                </p>
                <Link
                  to={
                    constants.ADDITIONAL_PATH +
                    "/pendants-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
                  }
                >
                  <button className="font-medium lg:text-sm text-xs font-century text-[#676767] border border-customGreen uppercase lg:px-5 lg:py-2 px-5 py-2">
                    Shop Now
                  </button>
                </Link>
              </div>
            </SwiperSlide>

            <SwiperSlide className="!mr-0">
              <div className="flex-col text-center lg:mb-0 mb-5">
                <img
                  src={constants.DEFAULT_IMAGE + "/bangle-set.jpg"}
                  alt="Icon"
                  className="mx-auto"
                />
                <h5 className="font-tiemann lg:text-2xl text-[18px] text-black font-normal mt-2 lg:mb-2 mb-0">
                  Bangles
                </h5>
                <p className="font-century font-medium lg:text-sm text-xs text-[#676767] lg:mb-4 mb-2 lg:h-9 h-auto">
                  Stack up on charm with single silver bangles in heritage and
                  modern styles.
                </p>
                <Link
                  to={
                    constants.ADDITIONAL_PATH +
                    "/bangles-silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
                  }
                >
                  <button className="font-medium lg:text-sm text-xs font-century text-[#676767] border border-customGreen uppercase lg:px-5 lg:py-2 px-5 py-2">
                    Shop Now
                  </button>
                </Link>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  ) : (
    <div className="text-center py-6 flex flex-col items-center">
      {/* SVG Image from Path */}
      <img
        src={constants.DEFAULT_IMAGE + "/loaderimagesilver.gif"}
        alt="loading logo"
        className="w-120 h-120"
      />
    </div>
  );
}

export default ProductDetails;
